import type { ComputedRef } from 'vue'
import { usarCatalogoQuery, usarContextoCatalogo, type EstadoCatalogoQuery } from '@next/compartilhados/catalogos'
import { DESCRITOR_CATALOGO_MOTIVO_PADRAO, type OpcaoMotivoPadrao } from '../catalogo-motivo-padrao.tipos'
import { usarOperacoesCatalogoMotivoPadrao } from './catalogo-motivo-padrao.injecao'
export const usarCatalogoMotivoPadrao = (
  habilitado?: ComputedRef<boolean>,
): EstadoCatalogoQuery<OpcaoMotivoPadrao> => usarCatalogoQuery({
  catalogo: DESCRITOR_CATALOGO_MOTIVO_PADRAO,
  contexto: usarContextoCatalogo(),
  consultar: usarOperacoesCatalogoMotivoPadrao().listarOpcoes,
  ...(habilitado ? { habilitado } : {}),
})
